import { LucideHourglass } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { StepperWeb } from "./web";
import { StepperWebEditor } from "./web-editor";

export default registerBlock({
  type: "stepper",
  name: "editorBlocksLibrary.blocks.stepper.title",
  description: "editorBlocksLibrary.blocks.stepper.description",
  Icon: LucideHourglass,
  category: BlockCategory.TRACKING,
  hasDynamicContent: true,
  components: {
    // email: {
    //   component: StepperEmail,
    //   editor: { component: StepperEmailEditor },
    // },
    web: {
      component: StepperWeb,
      editor: { component: StepperWebEditor },
    },
  },
});
